import { useAuth, useRequest, useView } from '@10000/react'
import { InputScreen, onboardBackground, useBackground, useShell, useStack } from '../../layout'
import { Avatar, Body, Box, DeleteTeamDialog } from '../../widgets'
import { InviteTeamLeader, TeamName } from './'
import { isPartner, userRoles } from '../../../lookups'
import { useState } from 'react'
import { teamIsOnboarded, useOnboardingStack } from '../Onboarding.jsx'

export const TeamLeader = ({ active, id, organisationId }) => {
  const request = useRequest('tenant')
  const { subscription, user: { avatar }, teams } = useView('tenant')
  const { push, replaceStack } = useStack()
  const onboardingStack = useOnboardingStack()
  const { user } = useAuth()
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false)

  useShell({
    active,
    mode: 'progress narrow',
    ...(isPartner(subscription) ? { step: 5, max: 8 } : { step: 3, max: 6 })
  })
  useBackground().set(mobile => ({ active, fade: false, ...onboardBackground(true, mobile) }))

  const assignCurrentUser = () => request('teamUpdated', { id, leaders: [user.id] })
    .then(() => push(TeamName, { props: { id, organisationId } }))

  const inviteNew = () => push(InviteTeamLeader, { props: { id, organisationId } })

  return <InputScreen
    title="Assign a Team Leader"
    description={userRoles.teamLeader.description}
    footerButton="Invite new Team Lead"
    onSubmit={inviteNew}
    altFooterButton="I&apos;m the Team Lead"
    altOnClick={assignCurrentUser}
  >
    <Avatar size="large" index={avatar} />
    {teamIsOnboarded(teams.find(x => id === x.id), user.id) &&
      <Box fullWidth justifyContent="center">
        <Box cursor="pointer" onClick={() => setDeleteDialogOpen(true)}>
          <Body underline bold alt italic>Delete Team</Body>
        </Box>
      </Box>
    }

    <DeleteTeamDialog
      open={deleteDialogOpen}
      onDelete={() => {
        replaceStack(onboardingStack)
        setDeleteDialogOpen(false)
      }}
      onClose={() => setDeleteDialogOpen(false)}
      id={id}
    />
  </InputScreen>
}